// CSV export helper. Browser-only.

const escapeCsvCell = (value) => {
  const v = value == null ? "" : String(value);
  if (/[",\n]/.test(v)) {
    return `"${v.replace(/"/g, '""')}"`;
  }
  return v;
};

export const downloadCsv = (filename, headers, rows) => {
  try {
    const headerLine = headers.join(",");
    const bodyLines = rows.map((row) =>
      headers.map((key) => escapeCsvCell(row[key])).join(",")
    );
    const csv = [headerLine, ...bodyLines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return true;
  } catch (err) {
    console.error("downloadCsv failed:", err);
    return false;
  }
};
